<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Rider Wallets</h1>
            <hr>
            <mdb-row>
                <mdb-col md="3">
                    <div class="form-group">
                        <input v-on:keyup.enter="searchData" v-model="search" type="text" placeholder="Name" class="form-control">
                    </div>
                </mdb-col>
                <mdb-col md="3">
                    <select @change="searchData" v-model="filter_active" class="browser-default custom-select">
                        <option value="" selected>All Active/Inactive</option>
                        <option value="1">Active</option>
                        <option value="2">Inative</option>
                    </select>
                </mdb-col>
                <mdb-col md="3">
                    <select @change="searchData" v-model="filter_type" class="browser-default custom-select">
                        <option value="" selected>Type</option>
                        <option value="PART">Part Time</option>
                        <option value="FULL">Full Time</option>
                        <option value="TEST">Test</option>
                    </select>
                </mdb-col>
            </mdb-row>
            <mdb-tbl responsive striped v-if="!loading">
                <mdb-tbl-head>
                <tr>
                    <th width="5%">#</th>
                    <th>Avatar</th>
                    <th>Profile</th>
                    <th>Balance</th>
                    <th>Hold</th>
                    <th>Limit</th>
                    <th>Action</th>
                </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                    <tr v-for="(partner, index) in partners" :key="partner.id">
                        <td>{{index+1}}</td>
                        <td>
                            <div class="avatar-image" :style="{backgroundImage:`url('`+getAvatar(partner.avatar)+`')`, border: partner.is_allow_online==1?'3px solid #00C851':'3px solid #ff4444'}" />
                        </td>
                        <td>
                            <div><span class="label-partner">Code: </span>{{partner.partner_code}}</div>
                            <div><span class="label-partner">Code Name: </span>[ {{partner.partner_code}} ] - {{partner.fullname}}</div>
                            <div><span class="label-partner">Full Name: </span>{{partner.fullname}}</div>
                            <div v-if="partner.partner_wallet"><span class="label-partner">Wallet Type: </span>{{partner.partner_wallet.type}}</div>
                        </td>
                        <td>
                            <div v-if="partner.partner_wallet" class="font-weight-bold">RM {{partner.partner_wallet.balance}}</div>
                        </td>
                        <td>
                            <div v-if="partner.partner_wallet">RM {{partner.partner_wallet.on_hold}}</div>
                        </td>
                        <td>
                            <div v-if="partner.partner_wallet">RM {{partner.partner_wallet.base_balance}}</div>
                        </td>
                        <td>
                            <div v-if="!partner.loading">
                                <mdb-tooltip v-if="!partner.partner_wallet" trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">Create Wallet</span>
                                    <a slot="reference">
                                    <mdb-btn @click="createWallet(partner)" color="secondary" size="sm"><mdb-icon icon="plus" /></mdb-btn>
                                    </a>
                                </mdb-tooltip>
                                <mdb-tooltip v-if="partner.partner_wallet" trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">View Transaction</span>
                                    <a slot="reference">
                                    <mdb-btn @click="$router.push({ name: 'partner_wallet_transactions', params: {id: partner.id} })" color="primary" size="sm"><mdb-icon far icon="eye" /></mdb-btn>
                                    </a>
                                </mdb-tooltip>
                                <mdb-tooltip v-if="partner.partner_wallet" trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">Manage Wallet</span>
                                    <a slot="reference">
                                    <mdb-btn color="success" @click="manageWallet(partner)" size="sm"><mdb-icon icon="wallet" /></mdb-btn>
                                    </a>
                                </mdb-tooltip>
                            </div>
                            <div v-if="partner.loading">
                                <mdb-spinner small />
                            </div>
                        </td>
                    </tr>
                </mdb-tbl-body>
            </mdb-tbl>
        </mdb-container>
        <mdb-row class="pt-3 pb-5" v-if="!loading">
            <mdb-col col="12">
                <mdb-pagination circle>
                    <mdb-page-nav prev :disabled="page==1" @click.native="switchPage(page-1)"></mdb-page-nav>
                    <mdb-page-item @click.native="switchPage(page_index)" v-for="page_index in count_pages" v-bind:key="page_index" :active="page==page_index">{{page_index}}</mdb-page-item>
                    <mdb-page-nav :disabled="page==count_pages" @click.native="switchPage(page+1)" next></mdb-page-nav>
                </mdb-pagination>
            </mdb-col>
        </mdb-row>
        <ManageWallet :visible="manage_wallet_visible" :close="closeComponents" :partner="focus_partner" />
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbBtn, mdbIcon, mdbTooltip, mdbSpinner, mdbTbl, mdbTblHead, mdbTblBody, mdbRow, mdbCol, mdbPagination, mdbPageItem, mdbPageNav } from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import {APP_FILE_URL} from '../js/config';
import ManageWallet from '../components/ManageWallet.vue'

export default {
    name: 'partner_wallet',
    components: {
        mdbContainer, mdbBtn, mdbIcon, mdbTooltip, mdbRow, mdbCol, mdbPagination, mdbPageItem, mdbPageNav,
        AppNavigation, mdbSpinner, ManageWallet, mdbTbl, mdbTblHead, mdbTblBody
    },
    data: ()=>({
        loading:false,
        partners: [],
        manage_wallet_visible: false,
        focus_partner: null,
        filter_type: "",
        filter_active: "",
        search: "",
        page: 1,
        count_pages: 1
    }),
    methods: {
        getData(){
            if(this.loading){
                return false;
            }
            sessionStorage.setItem("partner_wallet", JSON.stringify(this.$data));
            this.loading=true;
            this.partners=[];
            ajax({
                url: "admin/get_partners",
                data: {filter_active: this.filter_active, search: this.search, type: this.filter_type, page: this.page},
                complete: ()=>this.loading=false,
                success: result=>{
                    result.data.partners.forEach(element => {
                        element.loading=false;
                    });
                    this.partners=result.data.partners;
                    this.count_pages=result.data.count_pages;
                },
                fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
            })
        },
        getAvatar(avatar){
          return APP_FILE_URL+avatar;
        },
        createWallet(partner){
            if(partner.loading){
                return false;
            }
            partner.loading=true;
            ajax({
                url: "admin/create_partner_wallet",
                data: {partner_profile_id: partner.id},
                complete: ()=>partner.loading=false,
                success: result=>{
                    partner.partner_wallet=result.data;
                },
                fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
            })
        },
        closeComponents(){
            this.manage_wallet_visible=false;
        },
        manageWallet(partner){
            this.focus_partner=partner;
            this.manage_wallet_visible=true;
        },
        switchPage(page){
            this.page=page;
            this.getData();
        },
        searchData(){
            this.page=1;
            this.getData();
        }
    },
    mounted: function(){
        let temp_state=sessionStorage.getItem('partner_wallet', false);
        if(temp_state){
            let data=JSON.parse(temp_state);
            this.filter_active=data.filter_active;
            this.search=data.search;
            this.type=data.filter_type; 
            this.page=data.page;
        }
        sessionStorage.removeItem('partner_wallet')
        this.getData();
    }
}
</script>

<style scoped>
.avatar-image{
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 120px;
    width: 120px;
    border-radius: 120px;
}
.label-partner{
    font-size: 0.8rem;
    color: #9e9e9e;
}
</style>